import React, { useEffect, useState } from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import translate from '../../helpers/translate';
import ListProducts from './ListProducts';
import EntreesScreen from './entrees';
import DrinksScreen from './drinks';
import BreakFastScreen from './breakfast';
import MexicamScreen from './mexicam';
import DetailProduct from './DetailProduct';

function Index({setShowDrinks}) {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
   
    



    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 999}}>
        <LayoutContent showBack={true} setShowListProduct={()=>setShowDrinks(false)}>
            <div>
                    <img src={require('./assets/drinks.jpg')} style={{
                        objectFit: 'contain',
                        width: 700,
                }}/>
            </div>


            
        </LayoutContent>
        </div>
    );
}

export default Index;